import { ReactNode } from 'react';

import {
	AccordionItem,
	Box,
	ComposableTypography,
	ComposedElement,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { NavDown, NavUp } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';

export interface DrawerAccordionItemProps {
	header?: {
		label?: string;
		endContent?: ReactNode;
	};
	body?: {
		label?: string;
	};
}

export const DrawerAccordionItem = ({ header, body }: DrawerAccordionItemProps) => {
	return (
		<AccordionItem
			containerProps={{ background: '#fff', borderRadius: UIHelper.rem(8) }}
			header={{
				startContent: {
					containerProps: {
						flex: 1,
						padding: UIHelper.rem(24),
					},
					content: () => (
						<ComposableTypography
							baseProps={{
								appearance: 'subtitle-100-03',
							}}
							text={header?.label || ''}
							tags={{}}
						/>
					),
				},
				endContent: {
					containerProps: {
						padding: UIHelper.rem(24),
						marginLeft: 'auto',
					},
					content: (status) => (
						<Box sx={{ alignItems: 'center', gap: UIHelper.rem(24) }}>
							{header?.endContent}

							<ComposedElement
								size="xSmall"
								icon={{ source: status ? NavUp.Fill : NavDown.Fill }}
								sx={{
									fill: '#8694A7',
								}}
							/>
						</Box>
					),
					trigger: true,
				},
			}}
			body={{
				containerProps: {
					padding: UIHelper.rem(0, 24, 24),
				},
				content: (
					<ComposableTypography
						baseProps={{
							appearance: 'body-100-02',
							styles: {
								// Couldn't find CF token
								// eslint-disable-next-line @typescript-eslint/ban-ts-comment
								// @ts-ignore
								color: '#8694A7',
							},
						}}
						text={body?.label || ''}
						tags={{}}
					/>
				),
			}}
		/>
	);
};
